import { render, staticRenderFns } from "./TopFiveGainer.vue?vue&type=template&id=78bfd3ac&"
import script from "./TopFiveGainer.vue?vue&type=script&lang=js&"
export * from "./TopFiveGainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports